import React from 'react';
import { ExpressTruckIcon } from '../../helpers/icon-utils';
import {
  showTodayOrTomorrow,
  formatDate
} from '../../../components/helper/utils';
import {
  showEmptyShippingMessage
} from '../../helpers/pod-fulfillment-utils';
import { PodMessage } from '../PodMessage';

export const PriorityDeliveryOptions = ({
  product,
  showFasterPodSpacing = false,
  isNarrowPod = false
}) => {
  const priorityDeliveryOption = product?.fulfillment?.fulfillmentOptions
    ?.find((fo) => fo?.type === 'delivery')?.priorityDeliveryOptions?.[0];

  const hidePodSpacing = showEmptyShippingMessage(product);

  if (!priorityDeliveryOption) {
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    return showFasterPodSpacing ? <div className="sm:sui-min-h-[27.5px]" /> : null;
  }

  const endDate = priorityDeliveryOption?.date;
  const timeline = priorityDeliveryOption?.timeline;
  const formattedEndDate = endDate && formatDate(endDate, false);

  const dateText = showTodayOrTomorrow(endDate, true, timeline, formattedEndDate, false);

  return (
    <PodMessage
      messageIcon={ExpressTruckIcon}
      messageType="Faster Delivery"
      isNarrowPod={isNarrowPod}
    >
      Get it {dateText}
    </PodMessage>
  );
};